module.exports = __webpack_public_path__ + "img/numeralia_home2.a387fe05.svg";